import { observer } from 'mobx-react';
import ParticipantStore from '../../../../../ParticipantStore';
import ModalForm from './ModalForm';
import ModalSubmitted from './ModalSubmitted';
import { AddLicenseToParticipantsStore } from './Store';
import ParticipantsStore from '../../../../../ParticipantsStore';

interface Props {
  licenseAllocationsStore: AddLicenseToParticipantsStore;
  checkedParticipants: ParticipantStore[];
  participantsStore: ParticipantsStore;
}

function Display({ licenseAllocationsStore, checkedParticipants, participantsStore }: Props) {
  switch (licenseAllocationsStore.state.kind) {
    case 'waiting':
      return <></>;
    case 'loading':
    case 'loading-error':
    case 'initial-ready':
    case 'fetching-license-options':
    case 'fetching-license-options-error':
    case 'licenses-ready':
    case 'submitting':
    case 'submitting-error':
      return (
        <ModalForm
          state={licenseAllocationsStore.state}
          actions={{
            waiting: licenseAllocationsStore.waiting,
            submitting: licenseAllocationsStore.submitting,
          }}
          checkedParticipants={checkedParticipants}
          store={licenseAllocationsStore}
        />
      );
    case 'submitted':
      return (
        <ModalSubmitted
          state={licenseAllocationsStore.state}
          waiting={licenseAllocationsStore.waiting}
          participantsStore={participantsStore}
        />
      );
  }
}

export default observer(Display);
